import React from 'react';
import Alert from './Alert';
import classNames from 'classnames';
import {ALERT_WARNING__24} from '@homeaway/svg-defs';
import './AlertWarning.less';

function AlertWarning(props) {
    let buttonClasses = classNames('Alert--warning', props.className);
    return (
        <Alert
            {...props}
            className={buttonClasses}
            flairClassName="bg--accent-orange-light"
            svgClassName="text--accent-orange-light"
        />
    );
}

AlertWarning.propTypes = {
    ...Alert.propTypes
};

AlertWarning.defaultProps = {
    ...Alert.defaultProps,
    ariaLive: 'polite',
    svgMarkup: ALERT_WARNING__24
};

export default AlertWarning;
